import { graphql } from 'react-relay';

import { useQueryInterop } from '@confluence/apollo-relay-interop';
import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop-utils/entry-points/ApolloErrorInterop.ts';

import type {
	useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery$data,
	useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery$variables,
} from './__generated__/useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery.graphql.ts';

const useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery = graphql`
	query useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery {
		license {
			licenseConsumingUserCount
		}
	}
`;

export const useIsEligibleForNthUserHomeOnboardingLicensedUserCount = (
	skip: boolean,
): {
	loading: boolean;
	error: ApolloErrorInterop | undefined;
	licensedUserCount: number;
} => {
	const { data, loading, error } = useQueryInterop<
		useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery$data,
		useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery$variables
	>(useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery, { skip });

	const licensedUserCount = data?.license?.licenseConsumingUserCount ?? 0;

	return {
		loading,
		error,
		licensedUserCount,
	};
};
